<template>
  <row
    class="article-banner"
    :background-color="backgroundColor"
    :desktop-height="desktopHeight"
    :mobile-height="mobileHeight"
    :text-color="textColor"
  >
    <slot />
    <template #background>
      <!-- Desktop background image -->
      <img
        v-if="desktopBackgroundImage"
        class="article-banner__bg article-banner__bg--desktop"
        alt="Banner"
        title="Banner"
        :src="desktopBackgroundImage"
      />
      <!-- Mobile background image -->
      <img
        v-if="mobileBackgroundImage"
        class="article-banner__bg article-banner__bg--mobile"
        alt="Banner"
        title="Banner"
        :src="mobileBackgroundImage"
      />
    </template>
  </row>
</template>

<script>
import ArticleRow from './articleRow'

export default {
  components: {
    row: ArticleRow,
  },
  props: {
    /**
     * Banner background color
     */
    backgroundColor: {
      default: '',
      type: String,
    },

    /**
     * Desktop banner background image URL
     */
    desktopBackgroundImage: {
      default: '',
      type: String,
    },

    /**
     * Desktop banner height,
     * in px,
     * default: auto
     */
    desktopHeight: {
      default: '',
      type: String,
    },

    /**
     * Mobile banner background image URL
     */
    mobileBackgroundImage: {
      default: '',
      type: String,
    },

    /**
     * Mobile banner height,
     * in px,
     * default: auto
     */
    mobileHeight: {
      default: '',
      type: String,
    },

    /**
     * Banner text color
     */
    textColor: {
      default: '',
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.article-banner::v-deep {
  & .article-row__container > .article-col {
    @apply my-0;
  }
}
.article-banner__bg {
  @apply absolute inset-0 w-full h-full;
  @apply object-center object-cover;
  @apply z-0 pointer-events-none;
}

@screen mobile {
  /* Hide desktop background image */
  .article-banner__bg.article-banner__bg--desktop {
    @apply hidden;
  }
}

@screen desktop {
  /* Hide mobile background image */
  .article-banner__bg.article-banner__bg--mobile {
    @apply hidden;
  }
}
</style>
